export default "__VITE_ASSET__DSTLtvQW__"